// Carrinho lateral do Toh DS (desenho 02.7).
// - "Leve junto": adiciona o complementar ao carrinho e redesenha a gaveta.
// - "Garante o frete grátis": aparece no complementar que fecha o valor da regra da região.
(() => {
  const gaveta = () => document.getElementById('Cart-Drawer');

  // Adicionar do "Leve junto"
  document.addEventListener('click', async (evento) => {
    const botao = evento.target.closest('[data-leve-junto]');
    if (!botao || botao.getAttribute('aria-disabled') === 'true') return;
    evento.preventDefault();
    botao.classList.add('loading');
    botao.setAttribute('aria-disabled', 'true');
    try {
      await fetch(`${window.theme.routes.cart_add_url}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: Number(botao.dataset.leveJunto), quantity: 1 }),
      });
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      document.dispatchEvent(new CustomEvent('cart:updated'));
    } finally {
      botao.classList.remove('loading');
      botao.removeAttribute('aria-disabled');
    }
  });

  // "Garante o frete grátis": a barra da gaveta guarda o total e o mínimo da região (data-cart-total, data-minimum)
  function dicas() {
    const g = gaveta();
    const barra = g && g.querySelector('.cart-drawer__frete .free-shipping');
    if (!barra) return;
    const fixo = barra.classList.contains('free-shipping--fixo');
    const faltam = Number(barra.dataset.minimum) - Number(barra.dataset.cartTotal);
    g.querySelectorAll('.leve-item[data-preco]').forEach((item) => {
      const dica = item.querySelector('[data-leve-dica]');
      if (dica) dica.hidden = fixo || item.hasAttribute('data-frete-fixo') || !(faltam > 0 && Number(item.dataset.preco) >= faltam);
    });
  }

  function atualizar() {
    // A barra regional muda o mínimo depois de buscar o carrinho; a dica espera um instante.
    setTimeout(dicas, 600);
  }
  document.addEventListener('cart-drawer:atualizada', atualizar);
  document.addEventListener('cart-drawer:open', atualizar);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', atualizar);
  else atualizar();

  // Foco (acessibilidade): com a gaveta aberta, o Tab fica dentro dela; ao redesenhar a gaveta
  // (quantidade, remover, "Leve junto"), o foco volta ao mesmo lugar; ao fechar, volta ao ícone da sacola.
  const FOCAVEIS = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  const aberta = () => { const g = gaveta(); return !!g && g.classList.contains('active'); };
  const focaveis = (g) => [...g.querySelectorAll(FOCAVEIS)].filter((el) => el.getClientRects().length > 0);
  const caminho = (el, raiz) => {
    const partes = [];
    while (el && el !== raiz && el.parentElement) {
      partes.unshift(`${el.tagName.toLowerCase()}:nth-child(${[...el.parentElement.children].indexOf(el) + 1})`);
      el = el.parentElement;
    }
    return partes.join(' > ');
  };
  let ultimoFoco = '';
  document.addEventListener('keydown', (evento) => {
    if (evento.key !== 'Tab' || !aberta()) return;
    const g = gaveta();
    const lista = focaveis(g);
    if (!lista.length) return;
    const primeiro = lista[0];
    const ultimo = lista[lista.length - 1];
    if (!g.contains(document.activeElement)) {
      evento.preventDefault();
      primeiro.focus();
    } else if (evento.shiftKey && (document.activeElement === primeiro || document.activeElement === g)) {
      evento.preventDefault();
      ultimo.focus();
    } else if (!evento.shiftKey && document.activeElement === ultimo) {
      evento.preventDefault();
      primeiro.focus();
    }
  });
  document.addEventListener('focusin', (evento) => {
    const g = gaveta();
    if (g && evento.target !== g && g.contains(evento.target)) ultimoFoco = caminho(evento.target, g);
  });
  document.addEventListener('cart-drawer:atualizada', () => {
    const g = gaveta();
    if (!aberta() || !ultimoFoco || g.contains(document.activeElement)) return;
    const alvo = g.querySelector(`:scope > ${ultimoFoco}`) || g.querySelector('.side-panel-close');
    if (alvo) alvo.focus();
  });
  const vigiar = () => {
    const g = gaveta();
    if (!g) return;
    new MutationObserver(() => {
      if (g.classList.contains('active')) return;
      ultimoFoco = '';
      if (g.contains(document.activeElement) || document.activeElement === document.body) {
        const sacola = document.getElementById('cart-drawer-toggle');
        if (sacola) sacola.focus();
      }
    }).observe(g, { attributes: true, attributeFilter: ['class'] });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', vigiar);
  else vigiar();
})();
